export const UserRole = {
    USER: 0,
    ADMIN: 1
}
